<script lang="ts">
  import LoginForm from './LoginForm.svelte';
  import RegistrationForm from './RegistrationForm.svelte';
  import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@rgossiaux/svelte-headlessui';
  import { fade } from 'svelte/transition';
  import type { AuthFlowParameters } from 'shared/definitions/auth-object-definitions';

  export let initialTab: 'register' | 'login' = 'register';
  export let parameters: AuthFlowParameters = {};
  export let isTeacher = false;

  export let autofocus = false;

  const initialTabIndex = initialTab === 'register' ? 0 : 1;

  const tabClassFunction = (buttonClass: string) => ({ selected }: { selected?: boolean }) =>
    selected ? `${buttonClass} selected-tab` : buttonClass;
</script>

<div id="section-invite-registration">
  <TabGroup defaultIndex={initialTabIndex}>
    <div class="tablist">
      <TabList class="flex">
        <Tab class={tabClassFunction('register')}>Register</Tab>
        <Tab class={tabClassFunction('login')}>Sign in</Tab>
      </TabList>
    </div>
    <div class="border border-gray card-shadow rounded-b rounded-r">
      <TabPanels>
        <TabPanel>
          <div in:fade>
            <RegistrationForm {autofocus} {parameters} {isTeacher} on:registrationComplete />
          </div>
        </TabPanel>
        <TabPanel>
          <div in:fade>
            <LoginForm {autofocus} {parameters} hideRegistrationOption on:loginComplete />
          </div>
        </TabPanel>
      </TabPanels>
    </div>
  </TabGroup>
</div>

<style lang="postcss">
  #section-invite-registration {
    .tablist {
      @apply flex items-end h-12;
      :global(button) {
        @apply text-lg h-8 text-white self-end rounded-t-lg px-2 transition-all w-32 text-center border-t border-l border-r border-gray;
      }
      :global(button.selected-tab) {
        @apply text-2xl px-2 h-12 rounded-t-lg;
      }
      :global(.selected-tab) {
        :global(button[type='button']) {
        }
      }
      :global(button.register) {
        @apply bg-orange;
      }
      :global(button.login) {
        @apply bg-green;
      }
    }
  }
</style>
